
import XcoinsExchangeDetailDialog from "@/components/xcoins/ExchangeDetailDialog.vue";
import XcoinsPointsHero from "@/components/xcoins/PointsHero.vue";
import {
  buildOrderMeta,
  displayValue,
  getGoodsTypeLabelKey,
  getSoftwareCode,
  getStatusBadge,
  isApiSuccess,
  isClosedOrder,
  isCouponOrder,
  isCreditedVirtual,
  isPendingReceive,
  isSoftwareOrder,
  ORDER_STATUS,
  pickOrderList,
} from "@/utils/mallExchange";
import { openMallCouponSite, resolveSelectedMallSiteDomain } from "@/utils/mallSite";

/** 兑换筛选只传订单主状态：1 待发货、2 已完成、3 已关闭 */
const ORDER_FILTER_VALUES = [
  String(ORDER_STATUS.PENDING_SHIP),
  String(ORDER_STATUS.PENDING_RECEIVE),
  String(ORDER_STATUS.ISSUING),
];

function normalizeOrderFilter(value) {
  const status = String(value || "");
  return ORDER_FILTER_VALUES.includes(status) ? status : "";
}

const defaultDetail = {
  expiringSoonPoints: 0,
  total: 0,
  nickname: "",
  points: 0,
};

/** 积分流水：behaviorCode → 业务分类 / 标题模板 / 兜底图标 */
const behaviorMap = {
  1: {
    categoryKey: "xcoins.SHOP_BONUS",
    titleKey: "xcoins.LOG_TITLE_ORDER",
    icon: "icon-clipboard-list",
    className: "orange",
  },
  2: {
    categoryKey: "xcoins.CHECK_IN",
    titleKey: "xcoins.LOG_TITLE_CHECKIN",
    icon: "icon-calendar-smile",
    className: "blue",
  },
  3: {
    categoryKey: "xcoins.SIGN_UP",
    titleKey: "xcoins.LOG_TITLE_REGISTER",
    icon: "icon-calendar-smile",
    className: "orange",
  },
  4: {
    categoryKey: "xcoins.SUBSCRIBE",
    titleKey: "xcoins.LOG_TITLE_SUBSCRIBE",
    icon: "icon-clipboard-list",
    className: "green",
  },
  5: {
    categoryKey: "xcoins.IMPORT",
    titleKey: "xcoins.LOG_TITLE_IMPORT",
    icon: "icon-pencil-share",
    className: "blue",
  },
  6: {
    categoryKey: "xcoins.LOTTERY",
    titleKey: "xcoins.LOG_TITLE_LOTTERY_REWARD",
    icon: "icon-calendar-smile",
    className: "orange",
  },
  7: {
    categoryKey: "xcoins.ACTIVITY",
    titleKey: "xcoins.LOG_TITLE_ACTIVITY",
    icon: "icon-clipboard-list",
    className: "orange",
  },
  11: {
    categoryKey: "xcoins.POST",
    titleKey: "xcoins.LOG_TITLE_POST",
    icon: "icon-pencil-share",
    className: "green",
  },
  12: {
    categoryKey: "xcoins.COMMENT",
    titleKey: "xcoins.LOG_TITLE_COMMENT",
    icon: "icon-clipboard-list",
    className: "blue",
  },
  13: {
    categoryKey: "xcoins.LIKE",
    titleKey: "xcoins.LOG_TITLE_LIKE",
    icon: "icon-pencil-share",
    className: "orange",
  },
  14: {
    categoryKey: "xcoins.SAVE",
    titleKey: "xcoins.LOG_TITLE_COLLECT",
    icon: "icon-calendar-smile",
    className: "green",
  },
  15: {
    categoryKey: "xcoins.SHARE",
    titleKey: "xcoins.LOG_TITLE_SHARE",
    icon: "icon-home-move",
    className: "green",
  },
  20: {
    categoryKey: "xcoins.REFUND",
    titleKey: "xcoins.LOG_TITLE_ORDER_CANCEL",
    icon: "icon-pencil-share",
    className: "black",
  },
  21: {
    categoryKey: "xcoins.REDEEM",
    titleKey: "xcoins.LOG_TITLE_EXCHANGE",
    refundCategoryKey: "xcoins.REFUND",
    refundTitleKey: "xcoins.LOG_TITLE_EXCHANGE_REFUND",
    icon: "icon-home-move",
    className: "pink",
  },
  22: {
    categoryKey: "xcoins.MANUAL_ADJUSTMENT",
    titleKey: "xcoins.LOG_TITLE_CANCEL_ACCOUNT",
    icon: "icon-clipboard-list",
    className: "black",
  },
  23: {
    categoryKey: "xcoins.EXPIRED",
    titleKey: "xcoins.LOG_TITLE_EXPIRED",
    icon: "icon-calendar-smile",
    className: "black",
  },
  24: {
    categoryKey: "xcoins.LOTTERY",
    titleKey: "xcoins.LOG_TITLE_LOTTERY_DRAW",
    icon: "icon-home-move",
    className: "pink",
  },
  50: {
    categoryKey: "xcoins.MANUAL_ADJUSTMENT",
    titleKey: "xcoins.LOG_TITLE_MANUAL_ADD",
    deductTitleKey: "xcoins.LOG_TITLE_MANUAL_DEDUCT",
    icon: "icon-clipboard-list",
    className: "blue",
  },
};

export default {
  name: "pointsCenter",
  components: { XcoinsPointsHero, XcoinsExchangeDetailDialog },
  layout: "DefaultLayout",
  head() {
    return {
      title: this.$t("xcoins.MY_XCOINS"),
      meta: [
        {
          name: "keywords",
          content: "X-Coins center",
        },
        {
          name: "description",
          content: "X-Coins detail and X-Coins log list",
        },
      ],
    };
  },
  data() {
    return {
      tabOptions: [
        { labelKey: "xcoins.XCOINS_DETAILS", value: "detail" },
        { labelKey: "xcoins.REDEMPTION_RECORD", value: "exchange" },
      ],
      incomeTypeOptions: [
        { labelKey: "xcoins.ALL", value: "" },
        { labelKey: "xcoins.EARNED", value: "1" },
        { labelKey: "xcoins.SPENT", value: "2" },
      ],
      orderStatusOptions: [
        { labelKey: "xcoins.ORDER_STATUS_ALL", value: "" },
        { labelKey: "xcoins.ORDER_STATUS_PROCESSING", value: String(ORDER_STATUS.PENDING_SHIP) },
        { labelKey: "xcoins.ORDER_STATUS_COMPLETED", value: String(ORDER_STATUS.PENDING_RECEIVE) },
        { labelKey: "xcoins.ORDER_STATUS_CLOSED", value: String(ORDER_STATUS.ISSUING) },
      ],
      goodsNameInput: "",
      orderStatus: "",
      goodsName: "",
      searchTimer: null,
      exchangeLoadError: false,
      detailVisible: false,
      detailOrderId: "",
      detailFocus: "",
      copyingOrderId: "",
      usingCouponOrderId: "", // 正在解析站点域名的优惠券订单
      mallSiteDomain: "", // 当前选中国家的站点域名，缺失则隐藏使用优惠券
      failedLogIcons: {}, // 接口 icon 加载失败后回退 iconfont
    };
  },
  async asyncData({ $global, app, query, redirect, store }) {
    const activeTab = query.tab === "exchange" ? "exchange" : "detail";
    const currentPage = parseInt(query.page) || 1;
    const activeIncomeType =
      activeTab === "detail" && query.incomeType ? String(query.incomeType) : "";
    const orderStatus = normalizeOrderFilter(query.orderStatus);
    const goodsName = String(query.goodsName || "").trim();
    const pageSize = 10;
    const params = {
      page: currentPage,
      limit: pageSize,
    };

    if (activeIncomeType) {
      params.incomeType = Number(activeIncomeType);
    }

    let pointsDetail = { ...defaultDetail };
    let logList = [];
    let exchangeList = [];
    let total = 0;
    const pointToken = await app.$pointsCache.ensurePointToken();
    if (!pointToken) {
      redirect("/");
      return {
        pointsDetail,
        logList,
        exchangeList,
        total,
        currentPage,
        activeIncomeType,
        activeTab,
        pointToken: "",
        pageSize,
        orderStatus,
        goodsName,
        goodsNameInput: goodsName,
      };
    }

    const pointDetail = await app.$pointsCache.ensurePointDetail();
    pointsDetail = {
      ...defaultDetail,
      ...(pointDetail || {}),
    };

    if (activeTab === "detail") {
      try {
        const listRes = await app.$pointsCache.requestWithPointToken((token) => {
          return $global.pointsCenterLogList(params, token);
        });
        if (listRes.code === "200") {
          const listData = listRes.data?.list;
          logList = Array.isArray(listData) ? listData : [];
          total = Number(listRes.data?.total || logList.length);
        }
      } catch (e) {}

    } else {
      try {
        const exchangeParams = {
          ...params,
          goodsName,
        };
        if (orderStatus) {
          exchangeParams.orderStatus = Number(orderStatus);
        }
        const exchangeRes = await app.$pointsCache.requestWithPointToken((token) => {
          return $global.pointsMallOrderPage(exchangeParams, token);
        });
        if (isApiSuccess(exchangeRes)) {
          const picked = pickOrderList(exchangeRes);
          exchangeList = picked.list;
          total = picked.total;
        }
      } catch (e) {}

    }

    return {
      pointsDetail,
      logList,
      exchangeList,
      total,
      currentPage,
      activeIncomeType,
      activeTab,
      pointToken: store.state.pointToken || pointToken,
      pageSize,
      orderStatus,
      goodsName,
      goodsNameInput: goodsName,
    };
  },
  watch: {
    "$route.query": {
      handler(query) {
        this.syncQueryAndFetch(query);
      },
    },
    goodsNameInput() {
      if (this.activeTab !== "exchange") {
        return;
      }
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.applyGoodsSearch();
      }, 400);
    },
  },
  mounted() {
    this.loadMallSiteDomain();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    displayValue,
    buildOrderMeta,
    getGoodsTypeLabelKey,
    getStatusBadge,
    changeTab(value) {
      if (value === this.activeTab) {
        return;
      }

      const query = { page: 1 };
      if (value === "exchange") {
        query.tab = value;
        if (this.orderStatus) {
          query.orderStatus = this.orderStatus;
        }
        if (this.goodsName) {
          query.goodsName = this.goodsName;
        }
      }
      this.pushRoute({ path: "/user/xcoins", query });
    },
    changeIncomeType(value) {
      if (this.activeTab !== "detail") {
        return;
      }

      const query = { page: 1 };
      if (value) {
        query.incomeType = value;
      }
      this.pushRoute({ path: "/user/xcoins", query });
    },
    handleCurrentChange(page) {
      this.pushRoute({ path: "/user/xcoins", query: this.buildQuery({ page }) });
    },
    changeOrderStatus(value) {
      if (String(this.orderStatus) === String(value)) {
        return;
      }
      this.pushRoute({
        path: "/user/xcoins",
        query: this.buildQuery({ page: 1, orderStatus: value }),
      });
    },
    applyGoodsSearch() {
      const nextName = String(this.goodsNameInput || "").trim();
      if (nextName === this.goodsName) {
        return;
      }
      this.pushRoute({
        path: "/user/xcoins",
        query: this.buildQuery({ page: 1, goodsName: nextName }),
      });
    },
    clearGoodsSearch() {
      this.goodsNameInput = "";
      this.applyGoodsSearch();
    },
    buildQuery(overrides = {}) {
      const query = {
        page: overrides.page || this.currentPage,
      };
      const tab = overrides.tab !== undefined ? overrides.tab : this.activeTab;
      if (tab === "exchange") {
        query.tab = "exchange";
        const orderStatus =
          overrides.orderStatus !== undefined ? overrides.orderStatus : this.orderStatus;
        const goodsName =
          overrides.goodsName !== undefined ? overrides.goodsName : this.goodsName;
        if (orderStatus) {
          query.orderStatus = orderStatus;
        }
        if (goodsName) {
          query.goodsName = goodsName;
        }
      } else if (this.activeIncomeType) {
        query.incomeType = this.activeIncomeType;
      }
      return query;
    },
    pushRoute(route) {
      const result = this.$router.push(route);
      if (result && typeof result.catch === "function") {
        result.catch(() => {});
      }
    },
    async syncQueryAndFetch(query) {
      const nextTab = query.tab === "exchange" ? "exchange" : "detail";
      const nextPage = parseInt(query.page) || 1;
      const nextIncomeType =
        nextTab === "detail" && query.incomeType ? String(query.incomeType) : "";
      const nextOrderStatus = normalizeOrderFilter(query.orderStatus);
      const nextGoodsName = String(query.goodsName || "").trim();

      this.activeTab = nextTab;
      this.currentPage = nextPage;
      this.activeIncomeType = nextIncomeType;
      this.orderStatus = nextOrderStatus;
      this.goodsName = nextGoodsName;
      if (this.goodsNameInput !== nextGoodsName) {
        this.goodsNameInput = nextGoodsName;
      }
      await this.fetchActiveList();
      if (this.activeTab === "exchange") {
        this.scrollExchangeToolbarIntoView();
      }
    },
    /** 列表变空或变短时，把兑换筛选栏滚回视口（避免 Tab 被顶到屏外） */
    scrollExchangeToolbarIntoView() {
      if (this.activeTab !== "exchange") {
        return;
      }
      this.$nextTick(() => {
        const ref = this.$refs.exchangeToolbar;
        const node = ref && (ref.$el || ref);
        if (!node || typeof node.getBoundingClientRect !== "function") {
          return;
        }
        const topOffset = window.innerWidth <= 768 ? 88 : 120;
        const { top } = node.getBoundingClientRect();
        if (top < topOffset) {
          window.scrollTo({
            top: Math.max(0, window.scrollY + top - topOffset),
            behavior: "smooth",
          });
        }
      });
    },
    getListParams() {
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
      };

      if (this.activeTab === "detail" && this.activeIncomeType) {
        params.incomeType = Number(this.activeIncomeType);
      }

      if (this.activeTab === "exchange") {
        if (this.orderStatus) {
          params.orderStatus = Number(this.orderStatus);
        }
        if (this.goodsName) {
          params.goodsName = this.goodsName;
        }
      }

      return params;
    },
    async fetchActiveList() {
      if (!this.pointToken) {
        this.pointToken = await this.$pointsCache.ensurePointToken();
      }

      if (!this.pointToken) {
        return;
      }

      await this.refreshPointDetail();

      if (this.activeTab === "detail") {
        await this.fetchPointLogList();
      } else {
        await this.fetchExchangeList();
      }
    },
    async refreshPointDetail() {
      const pointDetail = await this.$pointsCache.ensurePointDetail();
      this.pointsDetail = {
        ...defaultDetail,
        ...(pointDetail || {}),
      };
    },
    async fetchPointLogList() {
      try {
        const listRes = await this.$pointsCache.requestWithPointToken((token) => {
          this.pointToken = token;
          return this.$global.pointsCenterLogList(this.getListParams(), token);
        });
        if (listRes.code === "200") {
          const listData = listRes.data?.list;
          this.logList = Array.isArray(listData) ? listData : [];
          this.exchangeList = [];
          this.total = Number(listRes.data?.total || this.logList.length);
          return;
        }
      } catch (e) {}

      this.logList = [];
      this.exchangeList = [];
      this.total = 0;
    },
    async fetchExchangeList(options = {}) {
      const keepCurrent = Boolean(this.exchangeList.length) && !options.force;
      try {
        const exchangeRes = await this.$pointsCache.requestWithPointToken((token) => {
          this.pointToken = token;
          return this.$global.pointsMallOrderPage(this.getListParams(), token);
        });
        if (isApiSuccess(exchangeRes)) {
          const picked = pickOrderList(exchangeRes);
          this.exchangeList = picked.list;
          this.logList = [];
          this.total = picked.total;
          this.exchangeLoadError = false;
          return;
        }
        throw new Error("exchange list failed");
      } catch (e) {
        this.exchangeLoadError = true;
        if (keepCurrent) {
          this.$message.error(this.$t("xcoins.REFRESH_FAILED"));
          return;
        }
        this.exchangeList = [];
        this.logList = [];
        this.total = 0;
      }
    },
    handleCoverError(event) {
      event.target.src = require("@/assets/image/integral/img_none.png");
    },
    getCardActions(item) {
      if (isClosedOrder(item)) {
        return [{ key: "reason", labelKey: "xcoins.VIEW_REASON", primary: true }];
      }
      if (isPendingReceive(item)) {
        return [
          { key: "logistics", labelKey: "xcoins.VIEW_LOGISTICS", primary: false },
          { key: "confirm", labelKey: "xcoins.CONFIRM_RECEIPT", primary: true },
        ];
      }
      if (isSoftwareOrder(item) && isCreditedVirtual(item) && getSoftwareCode(item)) {
        return [
          { key: "copy", labelKey: "xcoins.COPY", primary: false },
          { key: "code", labelKey: "xcoins.VIEW_SOFTWARE_CODE", primary: true },
        ];
      }
      if (isCouponOrder(item) && isCreditedVirtual(item)) {
        const actions = [{ key: "detail", labelKey: "xcoins.VIEW_DETAILS", primary: !this.mallSiteDomain }];
        if (this.mallSiteDomain) {
          actions.push({ key: "useCoupon", labelKey: "xcoins.USE_COUPON", primary: true });
        }
        return actions;
      }
      return [{ key: "detail", labelKey: "xcoins.VIEW_DETAILS", primary: true }];
    },
    handleCardAction(item, key) {
      if (key === "copy") {
        this.copyText(getSoftwareCode(item), item.id);
        return;
      }
      if (key === "confirm") {
        this.openConfirm(item.id);
        return;
      }
      if (key === "useCoupon") {
        this.openCouponSite(item);
        return;
      }
      this.openDetail(item, key === "code" ? "code" : key === "logistics" ? "logistics" : key === "reason" ? "reason" : "");
    },
    /** 按当前选中国家拉取 regions.domain，没有则隐藏使用优惠券 */
    async loadMallSiteDomain() {
      this.mallSiteDomain = await resolveSelectedMallSiteDomain(this.$global, this.$cookies);
    },
    /** 打开当前选中国家对应的商城站点 */
    async openCouponSite(item) {
      if (this.usingCouponOrderId) {
        return;
      }
      this.usingCouponOrderId = item && item.id ? item.id : "site";
      try {
        const url = this.mallSiteDomain || await resolveSelectedMallSiteDomain(this.$global, this.$cookies);
        this.mallSiteDomain = url;
        if (!url) {
          return;
        }
        openMallCouponSite(url);
      } finally {
        this.usingCouponOrderId = "";
      }
    },
    openDetail(item, focus = "") {
      if (!item || !item.id) {
        return;
      }
      this.detailOrderId = item.id;
      this.detailFocus = focus;
      this.detailVisible = true;
    },
    async openConfirm(id) {
      try {
        await this.$xcoinsConfirm({
          title: this.$t("xcoins.CONFIRM_RECEIPT"),
          message: this.$t("xcoins.CONFIRM_RECEIPT_TIP"),
          confirmText: this.$t("xcoins.CONFIRM_RECEIPT"),
          cancelText: this.$t("page.CANCEL"),
        });
      } catch (e) {
        return;
      }
      await this.confirmReceipt(id);
    },
    async confirmReceipt(id) {
      if (!id) {
        return;
      }
      try {
        const res = await this.$pointsCache.requestWithPointToken((token) => {
          return this.$global.pointsMallConfirmReceipt(id, token);
        });
        if (isApiSuccess(res)) {
          this.$message.success(this.$t("xcoins.STATUS_UPDATED"));
          this.handleConfirmed();
          return;
        }
        this.$message.error(res?.msg || this.$t("xcoins.STATUS_UPDATED"));
        this.handleConfirmed();
      } catch (e) {
        this.$message.error(this.$t("xcoins.REFRESH_FAILED"));
      }
    },
    handleConfirmed() {
      this.detailVisible = false;
      this.fetchExchangeList({ force: true });
    },
    async copyText(text, orderId) {
      if (!text) {
        return;
      }
      this.copyingOrderId = orderId || "";
      try {
        await this.$copyText(text);
        this.$message.success(this.$t("page.COPY_SUCCESS"));
      } catch (e) {
        this.$message.error(this.$t("xcoins.COPY_MANUAL"));
      } finally {
        this.copyingOrderId = "";
      }
    },
    /** 按行为码取分类、标题模板和兜底图标 */
    getBehaviorConfig(code) {
      return behaviorMap[Number(code)] || {
        categoryKey: "",
        titleKey: "",
        icon: "icon-clipboard-list",
        className: "blue",
      };
    },
    /** 流水图标只认 icon；空或加载失败回退行为 iconfont */
    getLogIconUrl(item) {
      const url = item && item.icon;
      if (!url || this.failedLogIcons[item.id || item.createTime]) {
        return "";
      }
      return url;
    },
    getLogIconClass(item) {
      const config = this.getBehaviorConfig(item && item.behaviorCode);
      return {
        [config.className]: true,
        "has-image": Boolean(this.getLogIconUrl(item)),
      };
    },
    markLogIconFailed(item) {
      const key = item && (item.id || item.createTime);
      if (!key) {
        return;
      }
      this.$set(this.failedLogIcons, key, true);
    },
    /** 业务分类按 behaviorCode 映射；兑换收入走退回 */
    getBehaviorLabel(item) {
      const config = this.getBehaviorConfig(item && item.behaviorCode);
      let key = config.categoryKey;
      if (Number(item && item.behaviorCode) === 21 && !this.isExpense(item) && config.refundCategoryKey) {
        key = config.refundCategoryKey;
      }
      return key ? this.$t(key) : "";
    },
    /** 流水标题：固定文案走 i18n，动态名只认 title */
    getLogTitle(item) {
      const config = this.getBehaviorConfig(item && item.behaviorCode);
      const title = item && item.title ? String(item.title) : "";
      let key = config.titleKey;
      const code = Number(item && item.behaviorCode);
      if (code === 21 && !this.isExpense(item) && config.refundTitleKey) {
        key = config.refundTitleKey;
      }
      if (code === 50 && this.isExpense(item) && config.deductTitleKey) {
        key = config.deductTitleKey;
      }
      if (!key) {
        return title || "-";
      }
      return this.$t(key, { title: title || "-" });
    },
    isExpense(item) {
      return Number(item.incomeType) === 2 || Number(item.points) < 0;
    },
    formatSignedPoints(item) {
      const points = Number(item.points || 0);
      const sign = this.isExpense(item) ? "-" : "+";
      return `${sign}${this.formatPoints(Math.abs(points))}`;
    },
    formatPoints(value) {
      const number = Number(String(value || 0).replace(/,/g, ""));
      return Number.isFinite(number) ? number.toLocaleString("en-US") : value;
    },
    formatTime(value) {
      if (!value) {
        return "";
      }
      return String(value).replace("T", " ").slice(0, 19);
    },
  },
};
